export default {
  FRONTEND_TRACKING_ENABLED: 'frontend_tracking_enabled',
};
